import LotterySuperGGLV2Prefab from "./LotterySuperGGLV2Prefab";
import isNumber = cc.js.isNumber;
import O1HD from "../../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

/**
 * 步数 刮刮乐
 */
@ccclass
export default class ShoveItemNode extends cc.Component {

    @property(cc.Label)
    lbNum: cc.Label = null;
    @property(cc.Node)
    maskNode : cc.Node = null;
    @property(cc.Node)
    judge1Node : cc.Node = null;
    @property
    mIndex : number = 0;
    @property(LotterySuperGGLV2Prefab)
    mParentScript : LotterySuperGGLV2Prefab = null;

    private flag1 : boolean = false;
    private mNum : number;

    onLoad () {
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchstart",this.touchStart.bind(this) );
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchmove",this.touchMove.bind(this) );

        O1HD.on("ShoveItemNode.reset" , this.reset , this );
    }

    start () {

    }

    reset(){
        this.flag1 = false;
        this.mNum = null;
        this.hasOpenFlag = false;
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.clear();
    }

    touchStart(e:cc.Event.EventTouch){
        if ( !this.mNum && this.mNum != 0 ) {
            if ( this.mParentScript.canTouch( this.mIndex ) == false ) {
                //如果不可以刮取
                O1HD.getModules().uiControlModule.showMessageBox("请按顺序刮奖",this.mParentScript.node );
                return;
            }
            this.mNum = this.mParentScript.getStepNum( this.mIndex );
            this.lbNum.string = `${this.mNum}`;
        }
    }
    touchMove(e:cc.Event.EventTouch){
        if ( !this.mNum ){
            return;
        }

        let distance = Math.abs( Math.floor( e.getLocation().sub( e.getPreviousLocation() ).mag() ) );
        if ( distance > 5 ) {
            //补点操作
            for ( let num = 0 ; num < distance ; num++ ) {
                let subLocation : cc.Vec2 = e.getLocation().sub( e.getPreviousLocation() );
                let actualLocation = e.getPreviousLocation().add( subLocation.div( distance ).mul( num ) );
                this._addCircle( this.maskNode.convertToNodeSpaceAR( actualLocation ) );
                this.checkJudgeNode( actualLocation );
            }
        }
        this._addCircle( this.maskNode.convertToNodeSpaceAR( e.getLocation() ) );
        this.checkJudgeNode( e.getLocation() );
    }

    //效果渲染
    maskGraphicsPos1:cc.Vec2[] = [];
    _addCircle(pos:cc.Vec2){
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.circle (pos.x,pos.y, 20 )
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.fill();
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.stroke();
        this.maskGraphicsPos1.push(pos);
    }

    /**
     * 检查是否过了 判断点
     * @param pos
     * @private
     */
    checkJudgeNode ( pos : cc.Vec2 ) {
        if ( this.judge1Node.getBoundingBoxToWorld().contains( pos ) ) {
            this.flag1 = true;
            this._checkFinish();
            return ;
        }
    }

    private hasOpenFlag : boolean = false;
    private _checkFinish(){
        if ( this.flag1 && !this.hasOpenFlag ) {
            this.hasOpenFlag = true;
            this.mParentScript.openStepNum( this.mNum );
            this.mParentScript.updateStepStatus();
        }
    }
}
